import { LTime } from '@app/components/date/LTime';
import { Seconds } from '@mi-front/core';
import { Duration } from '@mi-front/ui';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { MobileStepper } from '@mui/material';
import Button from '@mui/material/Button';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { BasicInfoWrapper, Pre, Title, Wrapper } from './elements';
import { FormattedAdoverlayMarkerType, FormattedAdoverlayType } from './utils';

function InfoAdOverlay(p: { adOverlay: FormattedAdoverlayType }) {
  const { formatMessage } = useIntl();
  return (
    <>
      <Pre>
        {formatMessage({
          id: 'logger.streamScreen.audit.adOverlayLabel',
          defaultMessage: 'Ad Overlay',
        })}
      </Pre>
      <Title>{p.adOverlay.brand}</Title>
    </>
  );
}

export default function AdOverlayInfo(p: { adOverlay: FormattedAdoverlayMarkerType }) {
  const adOverlay = p.adOverlay;
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = adOverlay.ads.length;
  const { formatMessage } = useIntl();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return adOverlay.ads.length === 1 ? (
    <Wrapper>
      <InfoAdOverlay adOverlay={adOverlay.ads[0]} />
      <div>
        <BasicInfoWrapper>
          {formatMessage({
            id: 'common.text.time',
            defaultMessage: 'Hora',
          })}
          : <LTime value={adOverlay.date} />{' '}
          {formatMessage({
            id: 'common.text.duration',
            defaultMessage: 'duración',
          })}
          :{' '}
          <Duration
            seconds={(adOverlay.ads[0].end_time - adOverlay.ads[0].start_time) as Seconds}
          />
        </BasicInfoWrapper>
        <div>
          <img
            src={adOverlay.ads[0].image_b64}
            alt={`${adOverlay.ads[0].brand} ad`}
            style={{ maxWidth: '16rem', maxHeight: '6rem' }}
          />
        </div>
      </div>
    </Wrapper>
  ) : (
    <Wrapper>
      <InfoAdOverlay adOverlay={adOverlay.ads[activeStep]} />
      <div>
        <BasicInfoWrapper>
          {formatMessage({
            id: 'common.text.time',
            defaultMessage: 'Hora',
          })}
          : <LTime value={adOverlay.date} />{' '}
          {formatMessage({
            id: 'common.text.duration',
            defaultMessage: 'duración',
          })}
          :{' '}
          <Duration
            seconds={
              (adOverlay.ads[activeStep].end_time - adOverlay.ads[activeStep].start_time) as Seconds
            }
          />
        </BasicInfoWrapper>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={adOverlay.ads[activeStep].image_b64}
            alt={`${adOverlay.ads[activeStep].brand} ad`}
            style={{ maxWidth: '16rem', maxHeight: '6rem' }}
          />
        </div>
      </div>
      <MobileStepper
        variant="text"
        steps={adOverlay.ads.length}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
            {formatMessage({
              id: 'common.text.next',
              defaultMessage: 'Siguiente',
            })}
            <KeyboardArrowRight />
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            <KeyboardArrowLeft />
            {formatMessage({
              id: 'common.text.back',
              defaultMessage: 'Atrás',
            })}
          </Button>
        }
      />
    </Wrapper>
  );
}
